export default __webpack_public_path__ + "static/media/Visual_joil_07.dfed23fb.jpg";